/*
 * @Author: zly
 * @Date: 2021-09-17 09:32:00
 * @LastEditTime: 2021-12-22 15:51:39
 * @LastEditors: zly
 * @Description: 获取登录信息
 */
import Cookies from 'js-cookie'
// import { getEnvConfig } from './envConfig'
// 获取token
export const getAccessToken = () => {
  if (window.top !== window.self) {
    return localStorage.getItem('access_token_shop') || ''
  }
  return Cookies.get('access_token_shop') || ''
}
// 获取用户名
export const getUserName = () => {
  if (window.top !== window.self) {
    return localStorage.getItem('username_shop') || ''
  }
  return Cookies.get('username_shop') || ''
}
// 清除信息
export const clearInfo = (val) => {
  Cookies.remove(val)
}
